import { PlaceholderCard } from "@/components/landing/shared";

interface StorefrontMockProps {
	cols: 2 | 3;
	showNavLinks?: boolean;
	shopLabel: string;
}

function StorefrontMock(prop: StorefrontMockProps) {
	const { cols, showNavLinks, shopLabel } = prop;
	return (
		<div style={{ background: "#fefdfb" }}>
			<div
				className="flex items-center justify-between gap-2 px-3 py-2.5"
				style={{
					background: "linear-gradient(100deg, var(--brand-2), var(--brand-1), var(--brand-2))",
				}}
			>
				<span className="h-2 w-10 shrink-0 rounded-full bg-white/45" />
				{showNavLinks && (
					<div className="hidden items-center gap-3 sm:flex">
						{[9, 7, 8, 6].map((w, i) => (
							<span
								key={i}
								className="h-1.5 rounded-full bg-white/30"
								style={{ width: `${w * 0.2}rem` }}
							/>
						))}
					</div>
				)}
				<span
					className="shrink-0 rounded-full bg-white px-2.5 py-1 text-[9px] font-bold"
					style={{ color: "var(--brand-1)" }}
				>
					{shopLabel}
				</span>
			</div>
			<div
				className="grid gap-2 p-2.5"
				style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}
			>
				{Array.from({ length: cols === 3 ? 3 : 4 }, (_, i) => (
					<div key={i}>
						<PlaceholderCard
							className="aspect-square rounded-md"
							style={{ animationDelay: `${i * 0.15}s` }}
						/>
						<div
							className="mt-1.5 h-1 w-3/5 rounded-full"
							style={{ background: "linear-gradient(90deg, var(--brand-1), var(--brand-2))" }}
						/>
					</div>
				))}
			</div>
		</div>
	);
}

export default StorefrontMock;
